let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, extractArgTypes } from '@utils/utils';

const elementTag = 'spw-header';

const subComponentTags = ['spw-header-navigation', 'spw-header-navigation-item'];

const argTypes = {
  ...withComponentControls(componentsData, { tag: elementTag }),
  ...extractArgTypes(componentsData, subComponentTags),
};

const meta: Meta = {
  title: 'Composants/En-tête de site (header)',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Section supérieure d'une page, servant de conteneur pour les éléments de navigation et les informations importantes.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/78fef5-en-tete-de-site-header)
        `,
      },
    },
  },
};

export default meta;

function htmlContent(slotArgs) {
  return /* HTML */ `
    <div slot="title">${slotArgs.siteTitle}</div>

    <div slot="user-space">
      <spw-header-lang>
        <spw-header-lang-item lang="Fr" active="true">
          <a href="https://wallonie.be/fr/">Fr</a>
        </spw-header-lang-item>
        <spw-header-lang-item lang="Nl"><a href="https://wallonie.be/nl/">Nl</a></spw-header-lang-item>
        <spw-header-lang-item lang="De"><a href="https://wallonie.be/de/">De</a></spw-header-lang-item>
        <spw-header-lang-item lang="En"><a href="https://wallonie.be/en/">En</a></spw-header-lang-item>
      </spw-header-lang>
    </div>

    <div slot="top-left">
      <spw-header-persona>
        <spw-header-persona-item persona="Citoyens">
          <a href="https://wallonie.be/fr/">Citoyens</a>
        </spw-header-persona-item>
        <spw-header-persona-item active="true" persona="Entreprises"><a href="https://wallonie.be/nl/">Entreprises</a></spw-header-persona-item>
        <spw-header-persona-item persona="Pouvoirs locaux"><a href="https://wallonie.be/de/">Pouvoirs locaux</a></spw-header-persona-item>
        <spw-header-persona-item persona="Non marchand"><a href="https://wallonie.be/en/">Non marchand</a></spw-header-persona-item>
      </spw-header-persona>
    </div>

    <div slot="right">
      <spw-search-field
        name="search"
        items='[
          {"url": "http://google.com", "label": "Item 1"},
          {"url": "http://google.com", "label": "Item 2"},
          {"url": "http://google.com", "label": "Item 3"},
          {"url": "http://google.com", "label": "Item 4"}
        ]'
        placeholder="Rechercher..."
      ></spw-search-field>
    </div>

    <spw-header-navigation>
      <spw-header-navigation-item is-active="${slotArgs.isActive}">
        <a href="#">Rubrique 1</a>

        <spw-header-navigation-dropdown>
          <spw-header-navigation-item>
            <a href="#">Sous-rubrique niveau 2</a>
            <spw-header-navigation-dropdown>
              <spw-header-navigation-item>
                <a href="#">Sous-rubrique niveau 3</a>
              </spw-header-navigation-item>
              <spw-header-navigation-item>
                <a href="#">Sous-rubrique niveau 3</a>
              </spw-header-navigation-item>
            </spw-header-navigation-dropdown>
          </spw-header-navigation-item>
          <spw-header-navigation-item>
            <a href="#">Sous-rubrique</a>
          </spw-header-navigation-item>
          <spw-header-navigation-item>
            <a href="#">Sous-rubrique</a>
          </spw-header-navigation-item>
          <spw-header-navigation-item>
            <a href="#">Sous-rubrique</a>
          </spw-header-navigation-item>
        </spw-header-navigation-dropdown>
      </spw-header-navigation-item>

      <spw-header-navigation-item>
        <a href="#">Rubrique 2</a>
      </spw-header-navigation-item>
      <spw-header-navigation-item>
        <a href="#">Rubrique 3</a>
      </spw-header-navigation-item>
      <spw-header-navigation-item>
        <a href="#">Rubrique 4</a>
      </spw-header-navigation-item>
      <spw-header-navigation-item>
        <a href="#">Rubrique 5</a>
      </spw-header-navigation-item>
      <spw-header-navigation-item>
        <a href="#">Rubrique 6</a>
      </spw-header-navigation-item>
    </spw-header-navigation>
  `;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);

  const masterProps = Object.keys(withComponentControls(componentsData, { tag: elementTag }) || {});

  Object.entries(args).forEach(([key, val]) => {
    if (masterProps.includes(key)) {
      element.setAttribute(key, val);
    } else if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    }
  });

  element.innerHTML = htmlContent(args);

  return element;
};

export const Default = Template.bind({});
Default.args = {
  isActive: false,
  siteTitle: 'Titre du site',
};
